var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preloader)?_c('Preloader'):_vm._e(),_c('h3',[_vm._v(" Welcome to Archive ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }